export default __webpack_public_path__ + "static/media/animation7BHS.f1e1310d.mp4";